import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-burgundy text-ivory px-6 py-20 text-center">
      <div className="max-w-4xl mx-auto flex flex-col items-center">
        <h3 className="font-serif text-2xl md:text-4xl tracking-[0.2em] mb-6">PADUA WEDDINGS</h3>
        <p className="font-sans font-light text-sm md:text-base mb-10 max-w-md opacity-70">
          A romantic Spanish Revival estate in the Claremont foothills.
        </p>
        <div className="w-12 h-px bg-estate-gold/40 mb-10"></div>
        <a 
          href="https://www.paduaweddings.com" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="font-sans text-[10px] uppercase tracking-[0.4em] hover:text-estate-gold transition-colors duration-300"
        >
          WWW.PADUAWEDDINGS.COM
        </a>
      </div>
    </footer>
  );
}